import { render } from "./DialogDistributionStatistics.vue?vue&type=template&id=53d284a5&scoped=true"
import script from "./DialogDistributionStatistics.vue?vue&type=script&lang=js"
export * from "./DialogDistributionStatistics.vue?vue&type=script&lang=js"

import "./DialogDistributionStatistics.vue?vue&type=style&index=0&id=53d284a5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d284a5"]])

export default __exports__